// 使用axios
import axios from 'axios'
import config from '../config'
// 创建axios副本(修改axios的默认值)
const _fetch = axios.create({
  baseURL: config.baseURL,
  withCredentials: true
})
export default _fetch
